export default __webpack_public_path__ + "48f538f095b5e26f92fd6300dd5cc397.jpg";